import { ComputedDatum, ResponsivePie } from "@nivo/pie";
import { IOverallDowntimeSummaryPieChartProps } from "./OverallDowntimeSummaryPieChartInterfaces";
import { calculateGraphTwoDigitPercentage } from "utilities/utilities";
import { useCallback } from "react";
export const OverallDowntimeSummaryPieChart = ({
    data,
    pieChartCenteredMetric,
    setHighlight,
    totalEventsInMinutesOrOccurrences,
}: IOverallDowntimeSummaryPieChartProps) => {
    const fills = data.map((dataItem) => ({
        match: {
            id: dataItem.id,
        },
        id: dataItem.name,
    }));

    const theme = {
        tooltip: {
            container: {
                display: "none",
            },
        },
        labels: {
            text: {
                fontSize: 16,
                fontFamily: "Open Sans",
                fontWeight: 400,
            },
        },
    };

    const handleHighlight = useCallback(
        (
            data: ComputedDatum<{
                id: string;
                name: string;
                value: number;
                color: string;
            }>,
        ) => {
            setHighlight({
                name: data["label"].toString(),
                value: calculateGraphTwoDigitPercentage(data["value"], totalEventsInMinutesOrOccurrences!),
            });
        },
        [setHighlight, totalEventsInMinutesOrOccurrences],
    );

    return (
        <ResponsivePie
            colors={{ datum: "data.color" }}
            data={data}
            theme={theme}
            margin={{ top: 40, right: 80, bottom: 40, left: 20 }}
            innerRadius={0.7}
            padAngle={1.2}
            cornerRadius={3}
            activeOuterRadiusOffset={8}
            borderWidth={1}
            borderColor={{
                from: "color",
                modifiers: [["darker", 0.2]],
            }}
            enableArcLabels={false}
            arcLinkLabelsSkipAngle={2}
            arcLinkLabelsTextColor="#505267"
            arcLinkLabelsThickness={1}
            arcLinkLabelsColor="#505267"
            arcLabelsSkipAngle={10}
            arcLabelsTextColor={{
                from: "color",
                modifiers: [["darker", 2]],
            }}
            layers={["arcs", "arcLabels", "arcLinkLabels", "legends", pieChartCenteredMetric]}
            fill={fills}
            legends={[]}
            onClick={(data) => handleHighlight(data)}
        />
    );
};
